import axios from 'axios';
import config from '@/config';
import { API_ENDPOINTS } from '@/constants';
import { setAccessToken } from './tokenStorage';
import { updateSocketAuth } from '@/services/socketService';

let refreshPromise = null;

/**
 * Single shared refresh call — prevents token rotation races
 * (React StrictMode double-mount, parallel 401 retries).
 * Uses a standalone axios instance to avoid circular imports with apiClient.
 */
export async function refreshAccessToken() {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = axios
    .post(`${config.apiUrl}${API_ENDPOINTS.AUTH.REFRESH}`, {}, { withCredentials: true })
    .then(({ data }) => {
      const payload = data.data;
      setAccessToken(payload.accessToken);
      updateSocketAuth(payload.accessToken);
      return payload;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}
